
import partition from './../utility/partition'

const formData = form => {
	return [].reduce.call(form.elements || [], (data, element) => {	
		if (!element.name) return data;
		if (element.type === 'checkbox')  {
			const existing = (data[element.name] !== undefined || Array.isArray(data[element.name]))
			if (!existing) data[element.name] = []
			if (element.checked) data[element.name].push(element.value)
		} else if (element.type === 'radio') {
			if (element.checked) data[element.name] = element.value
		} else {
			data[element.name] = element.value;
		}
		return data;
	}, {});
}

const getMatched = (items, fieldsOfStudy) => {
	
	const meta = items.map(el => {
		const programmeFields = el.getAttribute('data-programme-finder-field').split('|')
		const matches = programmeFields.filter(field => fieldsOfStudy.indexOf(field) > -1)
		return {
			// matched : fieldsOfStudy.length > 0 && fieldsOfStudy.length === matches.length,
			matched : matches.length > 0,
			matches,
			el
		}
	})

	const [matched, unmatched] = partition(meta, meta => meta.matched)
	matched.sort((a, b) => {
		if (a.matches.length === b.matches.length) return 0
		return a.matches.length > b.matches.length ? -1 : 1
	})

	return [matched, unmatched]
}

const hide = ({ el }) => {
	el.classList.add('minify')
	setTimeout(() => el.classList.add('hide'), 200)
}

const show = ({ el, matches }) => {

	// add tags
	const html = matches.map(match => `<span class="text-highlight">${match}</span>`).join('')
	el.querySelector('[data-programme-finder-tags]').innerHTML = html
	
	// sorts order
	el.parentNode.appendChild(el)
	
	el.classList.add('minify')
	el.classList.remove('hide')
	el.getBoundingClientRect()
	el.classList.remove('minify')
}

const status = (el, count, total) => {
	const programmes = (count === 1) ? 'programme' : 'programmes'
	el.parentNode.classList[count ? 'add' : 'remove']('gradient-top')
	el.innerHTML = count ? `<p>Showing <strong>${count}</strong> ${programmes} matching your selection</p>` : ''
}

export default function init() {

	const form = document.querySelector('.js-programme-finder__form')
	const statusEl = document.querySelector('.js-programme-finder__status')
	const items = [...document.querySelectorAll('[data-programme-finder-field]')]
	const hideEls = [
		...document.querySelectorAll('.js-programme-finder-hide-empty')
	]

	// add transition
	items.map(el => el.classList.add('transition-02'))

	if (!form) return;
	form.addEventListener('submit', e => e.preventDefault())
	
	const run = () => {
		const data = formData(form)
		const [matched, unmatched] = getMatched(items, data['field-of-study'] || [])
		unmatched.map(hide)
		setTimeout(() => matched.map(show), 210)
		status(statusEl, matched.length, items.length)

		hideEls.map(el => el.style.display = !matched.length ? 'none' : '')
	}

	run()
	const inputs = [...form.querySelectorAll('input[type=checkbox]')]
	inputs.map(input => input.addEventListener('change', run))
}